module.exports = __webpack_public_path__ + "img/classic.d2050bff.png";